import {Component, OnInit} from '@angular/core';
import {ContactsFilter} from '../../../../core/models/contacts/contacts.filter';
import {Institution} from '../../../../core/models/institutions/institutions.model';
import {ContactsService} from '../../../../core/services/contacts/contacts.service';
import {InstitutionsService} from '../../../../core/services/institutions/institutions.service';
import {PopulatedUser} from '../../../../core/models/users/users.model';
import {resToFileDownload} from '../../../../core/utils/file-export.helper';
import {FEDERAL_STATES, INSTITUTION_KINDS} from "../../../../core/constants";

@Component({
  selector: 'app-view-contacts',
  templateUrl: './view-contacts.component.html',
  styleUrls: ['./view-contacts.component.css'],
  standalone: false,
})
export class ViewContactsComponent implements OnInit {
  // pagination
  public pagination = {
    collectionSize: 0,
    pageSize: 10,
    selectedPage: 1,
  };

  // data
  public institutions: Institution[] = [];
  contacts: PopulatedUser<'institution'>[] = [];
  calcBaseDates: { label: string, value: string }[] = [];
  protected readonly INSTITUTION_KINDS = INSTITUTION_KINDS;
  protected readonly FEDERAL_STATES = FEDERAL_STATES;

  // filter
  public filterData: ContactsFilter = {};

  constructor(
    private institutionsService: InstitutionsService,
    private contactsService: ContactsService,
  ) {
  }

  ngOnInit() {
    this.getInstitutions();
    this.getContacts();
    this.getCalcBaseDates();
  }

  public handlePageChange(): void {
    this.getContacts(true);
  }

  public clearFilter() {
    this.filterData = {};
    this.resetPagination();
    this.getContacts();
  }

  public getContacts(onlyPageChange?: boolean): void {
    if (!onlyPageChange) {
      this.pagination.selectedPage = 1;
    }

    this.contactsService.getAll({
      ...this.filterData,
      ...this.pagination,
      populate: ['institution:name;kind'],
      select: ['firstname', 'lastname', 'email', 'telephone'],
    }).subscribe((res) => {
      this.contacts = res.docs;
      this.pagination.collectionSize = res.total;
    });
  }

  public exportContacts() {
    this.contactsService.exportContacts(this.filterData).subscribe(res => {
      resToFileDownload(res, 'Kontaktpersonen.xlsx', 'excel');
    });
  }

  public sendMailToCurrentList() {
    this.contactsService.getAll({
      ...this.filterData,
      populate: [],
      select: ['email'],
    }).subscribe(mailUsers => {
      const mails = mailUsers.docs.filter(c => c.email).map(c => c.email);
      open('mailto:?bcc=' + mails.join(';'));
    });
  }

  private getInstitutions(): void {
    this.institutionsService.getAll({
      select: ['name'],
    }).subscribe((res) => {
      this.institutions = res.docs;
    });
  }

  private getCalcBaseDates(){
    const today = new Date();
    // Loop through the last 4 years
    for (let i = 0; i < 4; i++) {
      const year = today.getFullYear() - i;
      // Loop through 4 quarters
      for (let quarter = 4; quarter >= 1; quarter--) {
        const quarterDate = new Date(year, (quarter - 1) * 3, 1); // First day of the quarter
        if (quarterDate < today) {
          this.calcBaseDates.push({
            label: `vor Q${quarter} ${year}`,
            value: `${year}-${(quarterDate.getMonth() + 1).toString().padStart(2, '0')}-01`,
          });
        }
      }
    }
  }

  private resetPagination() {
    this.pagination.pageSize = 10;
    this.pagination.selectedPage = 1;
  }
}
